<script lang="ts">
  import { Button, Col, Form, Input, Label, Row } from "sveltestrap";
  import { Cancel, EmailAddress, Mobile, Name, Others, Phone, Save, Work } from "../../../utils/Constant/Constant";
  import {personalData} from "../../../store"
  export let open:boolean
  let newFname:string 
  let newLname:string
  let newEmail:string
  let newPhone:number
  let setPersonalData:any
  personalData.subscribe((value)=>{
    setPersonalData = value
  })
  const handleNewContact = (e:any) => {
    e.preventDefault()
    let newContact = {
      fname:newFname,
      lname:newLname,
      email:newEmail,
      phone:newPhone
    }
    personalData.update(value => value = [...setPersonalData,newContact])
    newFname = "",
    newLname = "",
    newEmail = "",
    newPhone = null
    open = !open
  }
</script>
<Form class="form-bookmark needs-validation" novalidate>
    <Row class="g-2">
        <Col md="12" class="mb-3 mt-0">
          <Label for="con-name">{Name}</Label>
          <Row>
            <Col sm="6">
              <Input  id="con-name" type="text" required bind:value={newFname} placeholder="First Name" autocomplete="off"/>
            </Col>
            <Col sm="6">   
              <Input id="con-last" type="text" required bind:value={newLname} placeholder="Last Name" autocomplete="off"/>
            </Col>
          </Row>
        </Col>
        <Col md="12" class="mb-3 mt-0">
          <Label for="con-mail">{EmailAddress}</Label>
          <Input id="con-mail" type="text" required bind:value={newEmail} autocomplete="off" />
        </Col>
        <Col md="12" class="mb-3 my-0">
          <Label for="con-phone">{Phone}</Label>
          <Row>
            <Col sm="6">
              <Input id="con-phone" type="number" required bind:value={newPhone} autocomplete="off" />
            </Col>
            <Col sm="6">
              <Input type="select" name="select" id="exampleSelect" value="Mobile">
                <option>{Mobile}</option>
                <option>{Work}</option>
                <option>{Others}</option>
              </Input>
            </Col>
          </Row>
        </Col>
    </Row>
    <Button color="secondary" on:click={(event)=>handleNewContact(event)}>{Save}</Button>
    <Button color="primary" on:click={()=>(open = !open)} >{Cancel}</Button>
</Form>